<div class="profile-container hidden-xs">
  <div class="page-title" translate>moniepoint.profile</div>
  <nz-breadcrumb nzSeparator=">">
    <nz-breadcrumb-item>
      <a [routerLink]="'../dashboard'" translate>moniepoint.dashboard_caps</a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a translate>moniepoint.profile</a>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</div>
<div>
  <app-profile [context]="'agent-manager'"></app-profile>
</div>
